export default __webpack_public_path__ + "static/media/Jitsi-documentation.5505b71d.md";